import Carousel from '../../../components/Carousel'
import React, {useEffect, useState} from 'react'
import {ModeleVehiculeEntre} from '../../../components/Models'
import moment from 'moment'
import {KTSVG} from '../../../_metronic/helpers'

const VehiculeToShowPage = ({
  vehicule,
  setVehiculeToShow,
}: {
  vehicule: ModeleVehiculeEntre
  setVehiculeToShow: any
}) => {
  const [imgArr, setImgArr] = useState<any>([])
  useEffect(() => {
    const loadImages = async () => {
      if (!vehicule) return

      const immat = vehicule?.immatriculation
      const nombrePhotos =
        vehicule?.nombrePhotos && vehicule.nombrePhotos > 0
          ? vehicule.nombrePhotos
          : 15

      if (!immat || nombrePhotos <= 0) {
        setImgArr([])
        return
      }

      const firstImmatChar = immat.substring(0, 1);

      const arrTemp = Array.from(
        { length: nombrePhotos },
        (_, i) => `Photos${firstImmatChar}/${immat}_${i + 1}.jpg`
      )

      // Vérification de l'existence des images sur le cloud
      const existingImages = await Promise.all(
        arrTemp.map(
          (relativeUrl) =>
            new Promise<string | null>((resolve) => {
              const img = new Image();
              img.onload = () => resolve(relativeUrl);
              img.onerror = () => resolve(null);
              img.src = `https://d1zsawkzupb9kl.cloudfront.net/${relativeUrl}`;
            })
        )
      );

      setImgArr(existingImages.filter(Boolean));
    };

    loadImages()
  }, [vehicule])

  return (
    <>
      <div className='card p-8'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='d-flex justify-content-end'>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary mt-n6 me-n6 mb-1'
                onClick={() => {
                  setVehiculeToShow(undefined)
                }}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='position-relative'>
              <i
                className='position-absolute bi bi-zoom-in fs-2'
                data-bs-toggle='modal'
                data-bs-target='#vehiculeDetailImageModal'
                style={{
                  cursor: 'pointer',
                  zIndex: 1,
                  top: '15px',
                  right: '15px',
                }}
              ></i>
              <Carousel
                imagesArray={imgArr}
                loading={false}
                nomPiece={''}
                taille={'600x340'}
                width={115}
                indicator={1}
                isVehic={true}
              />
              <div
                className='modal fade'
                id='vehiculeDetailImageModal'
                aria-labelledby='vehiculeDetailImageModalLabel'
                aria-hidden='true'
              >
                <div className='modal-dialog modal-dialog-centered modal-xl'>
                  <div className='modal-content'>
                    <div className='modal-header'>
                      <h5 className='modal-title' id='vehiculeDetailImageModalLabel'>
                        Image du véhicule
                      </h5>
                      <div
                        className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                        data-bs-dismiss='modal'
                        aria-label='Close'
                      >
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr061.svg'
                          className='svg-icon svg-icon-2x'
                        />
                      </div>
                    </div>
                    <div className='modal-body text-center'>
                      <Carousel
                        imagesArray={imgArr}
                        loading={false}
                        nomPiece={''}
                        taille={'1024x600'}
                        width={150}
                        indicator={2}
                        isVehic={true}
                        displayMiniature={7}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-12'>
            <h3 className='my-4'>Information sur le véhicule</h3>
            <div key={vehicule.id} className='mt-5' style={{lineHeight: '1'}}>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Modèle</div>
                <div className='mb-5 fs-4 bold'>{vehicule.vehicule?.modele?.nom}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Immatriculation</div>
                <div className='mb-5 fs-4 bold'>{vehicule.immatriculation}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Numéro d’identification</div>
                <div className='mb-5 fs-4 bold'>{vehicule.numero}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Mise en circulation</div>
                <div className='mb-5 fs-4 bold'>
                  {vehicule.datePremiereImmat == ''
                    ? ''
                    : moment(vehicule.datePremiereImmat).format('DD/MM/YYYY')}
                </div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>N° série</div>
                <div className='mb-5 fs-4 bold'>{vehicule.vin}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Genre</div>
                <div className='mb-5 fs-4 bold'>{vehicule.vehicule?.modele?.type?.code}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Puissance</div>
                <div className='mb-5 fs-4 bold'>{vehicule.vehicule?.modele?.puissance}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Boîte de vitesse</div>
                <div className='mb-5 fs-4 bold'>{}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Type variante version</div>
                <div className='mb-5 fs-4 bold'>{}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Date CG</div>
                <div className='mb-5 fs-4 bold'>{}</div>
              </div>
              <div className='d-flex justify-content-between'>
                <div className='mb-5 bold text-gray-600 fs-4'>Contrôle SIV</div>
                <div className='mb-5 fs-4 bold'>{}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export {VehiculeToShowPage}
